'use strict'

var tester = require('../util/tester')
var filter = require('./filter')

module.exports = function filterNot (test) {
  test = tester(test)
  return filter(function (data) { return !test(data) })
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/pull-stream/throughs/filter-not.js
// module id = 693
// module chunks = 0